import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';
import * as moment from 'moment';

export function validatorDates(start: string, end: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const startDate: moment.Moment | any = control.get(start)?.value;
    const endDate: moment.Moment | any = control.get(end)?.value;
    if (!moment(startDate, 'DD.MM.YYYY').isValid()) {
      control.get(start)?.setErrors({isInvalidDate: true})
    }

    if (!moment(endDate, 'DD.MM.YYYY').isValid()) {
      control.get(end)?.setErrors({isInvalidDate: true})
    }

    if (!moment(startDate, 'DD.MM.YYYY').isValid() || !moment(endDate, 'DD.MM.YYYY').isValid()) {
      return null
    }

    return moment(startDate, 'DD.MM.YYYY').isAfter(moment(endDate, 'DD.MM.YYYY'), 'day') ? {isAfterEnd: true} : null;
  };
}

export function validatorMonths(start: string, end: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const startDate: moment.Moment | any = control.get(start)?.value;
    const endDate: moment.Moment | any = control.get(end)?.value;
    return (
      moment(endDate).format('DD.MM'),
      moment(endDate).isBetween(moment(startDate), moment(startDate).add(1, 'M')) ? {isDateInMonth: true} : null
    );
  };
}
